define(
  'configDefaultSearchParams',[
  ],
  () => {
    'use strict';

    const cache = {};
    const defaultSearchParams =
    {
      activeAdult:
      {
        regex: /\/state\/[a-z-]*\/active-adult*/,
        searchParam: {
          Adult: true,
          AllowStateSearch: 1,
          IncludeMpc: false,
          MarketId: 0
        }
      },
      luxuryHomes:
      {
        regex: /\/state\/[a-z-]*\/luxury-homes*/,
        searchParam: {
          LuxuryHomes: true,
          AllowStateSearch: 1,
          IncludeMpc: false,
          MarketId: 0
        }
      },
      gatedCommunities:
      {
        regex: /\/state\/[a-z-]*\/gated-communities*/,
        searchParam: {
          Gated: true,
          AllowStateSearch: 1,
          IncludeMpc: false,
          MarketId: 0
        }
      },
      golfCourse:
      {
        regex: /\/state\/[a-z-]*\/golf-course-homes*/,
        searchParam: {
          GolfCourse: true,
          AllowStateSearch: 1,
          IncludeMpc: false,
          MarketId: 0
        }
      }
    };

    /**
     * @private
     * getDefaultSearchParamsMemoizer: evaluate the url to get the search params.
     *
     */
    function getDefaultSearchParamsMemoizer(url) {
      const values = Object.values(defaultSearchParams);

      for (let i = 0; i < values.length; i += 1) {
        const value = values[i];
        if (value.regex.test(url)) {
          return value.searchParam;
        }
      }

      return {};
    }

    /**
     * @public
     * getSearchParams: get the search params according to the url.
     *
     */
    function getSearchParams() {
      const url = window.location.href.toLowerCase();
      const value = cache[url] || getDefaultSearchParamsMemoizer(url);

      if (value && !cache[url]) {
        cache[url] = value;
      }

      return value;
    }

    return {
      getDefaultSearchParams: getSearchParams
    };
  }
);

